import * as api from 'config/axios';
import * as endpoints from './endpoints';

export const getRecipientConnectionGrid = (params) => {
  return api.sendPost(endpoints.GET_RECIPIENT_CONNECTION_GRID, params);
};

export const getRecipientConnectionDetail = (params) => {
  return api.sendGet(endpoints.GET_RECIPIENT_CONNECTION_DETAIL, {
    params: params,
  });
};

export const deleteRecipientConnection = (params) => {
  return api.sendPost(endpoints.DELETE_RECIPIENT_CONNECTION, params);
};

export const saveRecipientConnection = (params) => {
  return api.sendPost(endpoints.SAVE_RECIPIENT_CONNECTION, params);
};

export const checkRecipientPublishRequirement = (params) => {
  return api.sendPost(endpoints.CHECK_RECIPIENT_PUBLISH_REQUIREMENT, params);
};
